import { useState, useEffect } from 'react';
import { getStartOfWeek } from '../../dateUtils';
import { useSelector } from 'react-redux';
import { selectCurrentVenue } from '../../../redux/slices/currentUserSlice';

/**
 * Hook to generate an array of dates for a week based on a selected date. Uses the startOfWeekIndex from the current venue.
 * @param {Date} selectedDate - The date to generate the week from
 * @returns {Object} - Contains weekDays array and startOfWeek timestamp
 */
export const useWeekDays = (selectedDate = new Date()) => {
  const [weekDays, setWeekDays] = useState([]);
  const [startOfWeek, setStartOfWeek] = useState(null);
  const { startOfWeekIndex } = useSelector(selectCurrentVenue);

  useEffect(() => {
    if (selectedDate) {
      const startOfWeekDate = getStartOfWeek(selectedDate, startOfWeekIndex);
      setStartOfWeek(startOfWeekDate);

      const days = Array.from({ length: 7 }, (_, i) => {
        const day = new Date(startOfWeekDate);
        day.setDate(day.getDate() + i);
        return day;
      });

      setWeekDays(days);
    }
  }, [selectedDate, startOfWeekIndex]);

  return { weekDays, startOfWeek };
};
